<template>
    <div class="move">
        <div class="header" :style="{'background-image':'url('+tabs[active]['bg']+')'}">
            <div v-for="(item,index) in tabs" class="tab" :key="index" :style="{left:item.l,top:item.t}" @click="change(item,index)"></div>
        </div>
        <div class="body">
            <div class="list">
                <div class="info" @click="gorule"></div>
                <div class="item" v-for="item in list" :key="item.id" @click="goDetail(item)">
                    <div class="title">
                        <div class="it">{{item.title}}</div>
                        <div class="cont"><img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20220326/1648297476/428663.png"  alt="">时间：{{item.start_time_show}} ～ {{item.end_time_show}}</div>
                    </div>
                    <img :src="require('assets/img/mwap/wmap_right.png')"  alt="">

                </div>
                <div class="other"  v-if="list.length == 0">
                    <img style="width:3rem;height:3.54rem" src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230615/1686813158/338324.png" alt="">
                </div>
            </div>
        </div>
         <div class="draw" @click="godraw">

         </div>
    </div>
</template>
<script>
import "./index.less"
export default {
    data() {
        return {
            month: '10',
            tabs: [
                {
                    bg: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230610/1686385445/489090.png',
                    month: '06',
                    m: 6,
                    l: '.42rem',
                    t: '1.32rem'
                },
                {
                    bg: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230610/1686385445/53222.png',
                    month: '07',
                    m: 7,
                    l: '1.76rem',
                    t: '.4rem'
                },
                {
                    bg: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230615/1686813158/909756.png',
                    month: '08',
                    m: 8,
                    l: '3.16rem',
                    t: '.1rem'
                },
                {
                    bg: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230610/1686385445/211514.png',
                    month: '09',
                    m: 9,
                    l: '4.56rem',
                    t: '.4rem'
                },
                {
                    bg: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230610/1686385445/446847.png',
                    month: '10',
                    m: 10,
                    l: '5.84rem',
                    t: '1.32rem'
                }
            ],
            active: 4,
            list: []
        }
    },
    mounted() {
        this.getlist()
    },
    methods: {
        godraw() {
            this.$router.push({name:'luckdraw',params:{acid:2}})
        },
        gorule() {
            window.location.href = 'https://mp.weixin.qq.com/s?__biz=MzI4NTEzOTk3Nw==&mid=2651906923&idx=1&sn=b4a84cf2a473bbdb4111806c04eff857&chksm=f014f60dc7637f1bf5067cf55ea95bd0f8e605dcd9389386bebd2b5e019e084bb772fe0f814a#rd'
        },
        goDetail(val) {
            if(val.jump_url) {
                if(val.jump_url.indexOf('https') != -1) {
                    window.location.href = val.jump_url
                    return
                }
                wx.miniProgram.navigateTo({
                    url:val.jump_url
                });
                return
            }
            this.$router.push({name:'sportsDetail',params:{matchid:val.match_id,item_sub_id:val.id}})
        },
        getlist() {
            let query  = {
                matchid: this.$route.params.matchid,
                month: this.month
            }
            this.$api.sports.getMlist(query).then(res=>{
                if(res.status === 200) {
                    this.list = res.data
                }
            })
        },
        change(item,index) {
            this.month = item.month
            this.active = index
            this.getlist()
        }
    }
}
</script>
